// Chef-style v5 authentication API (users-api5 / login.zuppler.com).
// Replaces the old hellojs OAuth2 flow against users.zuppler.com.
// Backend: carts-api/apps/users_api — see router.ex scope "/v5".

export interface LoggedInUser {
  id: number
  name: string
  email: string
  phone: string
  oauth_token: string
  refresh_token: string
  token_expires_at: number // epoch seconds
  refresh_token_expires_at: number // epoch seconds
  ag_roles: string[]
  access_group_ids: number[] // first element = active access group
  provider: string
  passwordless_auth_exists: boolean
}

// Same error formatting as chef (src/common/util.ts formatBackendErrors)
export function formatBackendErrors(errObj: any): string {
  if (typeof errObj == 'string') return errObj
  if ('message' in errObj) return errObj.message
  if ('response' in errObj) return errObj.response
  let errString = ''
  if (errObj && typeof errObj == 'object' && errObj.errors) {
    const { errors } = errObj
    Object.keys(errors).map((key) => {
      if (typeof errors[key] !== 'string') {
        errors[key].map((err: string) => (errString += ''.concat(key, ': ', err, '. ')))
      } else {
        errString += `${key}: ${errors[key]}.`
      }
    })
  }
  return errString || 'Something went wrong'
}

const post = <T>(path: string, body: any): Promise<T> =>
  fetch(`${USERS_API_V5}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then((res) =>
    res.ok
      ? res.json()
      : res.json().then((data) => {
          // same convention as chef: callers check status === 400 to drop the session
          const err: any = formatBackendErrors(data)
          err.status = res.status
          return Promise.reject(err)
        })
  )

export const AuthV5Api = {
  getAuthToken: (email: string, password: string): Promise<LoggedInUser> =>
    post('/get_auth_token', { email: email.trim().toLowerCase(), password }),

  requestSignInOtp: (phone: string): Promise<any> => post('/signin/init', { phone: phone.trim() }),

  verifySignInOtp: (phone: string, code: string): Promise<LoggedInUser> =>
    post('/signin/confirm', { phone: phone.trim(), code: code.trim() }),

  refreshToken: (refresh_token: string): Promise<LoggedInUser> => post('/refresh_token', { refresh_token }),

  forgetPassword: (email: string): Promise<any> =>
    post('/forget_password', { email: email.trim().toLowerCase() }),
}